export default "__VITE_ASSET__6e39436c__"